import { render, staticRenderFns } from "./consolidated-request-documents.vue?vue&type=template&id=bd8163a2"
import script from "./consolidated-request-documents.vue?vue&type=script&lang=js"
export * from "./consolidated-request-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports